<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item>角色设置</el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to='addUser?role_id=5'>
          <el-button size="mini" type="primary">新增角色</el-button>
        </router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="">
        <el-select v-model="form.status" placeholder="状态">
          <el-option label="全部状态" value="0">全部状态</el-option>
          <el-option label="启用" value="1">启用</el-option>
          <el-option label="禁用" value="2">禁用</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="form.words" placeholder="请输入关键词">
          <template slot="prepend"><i class="el-icon-search"></i></template>
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="searchUser">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="name"
        label="账号">
      </el-table-column>
      <el-table-column
        prop="company"
        label="公司">
      </el-table-column>
      <el-table-column
        prop="role_id"
        label="角色">
        <template slot-scope="scope">
          <p v-show="scope.row.role_id==1">子公司</p>
          <p v-show="scope.row.role_id==2">供应商</p>
          <p v-show="scope.row.role_id==4">子公司负责人</p>
          <p v-show="scope.row.role_id==5">收货员</p>
          <p v-show="!scope.row.role_id">超级管理员</p>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        width="120">
        <template slot-scope="scope">
          <p v-if="scope.row.status==1">启用</p>
          <p v-if="scope.row.status!=1">禁用</p>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="success" v-if="!(showBtn==3&&scope.row.role_id==3)" plain @click="editUser(scope.row.id)">编辑</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delUser(scope.row.id)" 
            title="确定删除收货员吗？"
          >
            <el-button v-if="showBtn<1" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
          
        </template>
      </el-table-column>
    </el-table>
    <p>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="form.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
</el-card>
</template>
<script>
import userFunction from "@/api/user"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      tableData:[],
      form:{
        limit:10,
        page:1,
        role_id:5,
        words:'',
        status:"0",
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    handleSizeChange(val){
      this.form.limit = val
      this.getList()
    },
    handleCurrentChange(val){
      this.form.page = val
      this.getList()
    },
    getList(){
      userFunction.getList(this.form,this).then(res=>{
        this.tableData = res.data
        this.total = res.total
      }).catch(err=>{
        this.$message.error(err);
      })
    },
    editUser(id){
      this.$router.push({path: '/home/editUser',query: {id: id}})
    },
    delUser(id){
      userFunction.delUser({vcode:sessionStorage.getItem('token'),id:id},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err);
      })
    },
    searchUser(){
      this.getList()
    },
  },
  mounted () {
    this.getList()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/set/receiverList.vue